import React from "react"
import Index from "../Index"
import { contentLayout, modules } from "../../config/pages"
import { useUser } from "../../contexts/UserContext"
import Forbidden from "../Forbidden"

function CreateTemplate (){
  const {user} = useUser()
  let view = contentLayout[modules.CreateTemplate]
  if(user.permissions.views.length && !user.permissions.views.join().includes(modules.CreateTemplate.toLowerCase())){
    view = Forbidden
  }
  return(
  <Index content={view} module={modules.CreateTemplate}></Index>
 )
}

export default CreateTemplate
